import React from "react";
import {findDOMNode} from "react-dom";
import Popover from "../../../../../gd-components/gd-popover/popover";
import AddReaction_PopoverContent from "../../../../../gd-components/reactions/add-reaction/popover-content";
import {FieldPopoverMenuProps} from "../../../dropdown/components/popover/popover-menu";
import Reactions from "../../../../../model2/reaction/reactions";

export default function FieldReaction_Popover(props:FieldPopoverMenuProps) {

    const hidePopover = () => props.parent.hidePopover()

    const onSelect = (reationType:number) => {

        // const currentValue : Reactions = new Reactions(props.field.getViewValue(props.model))
        const currentValue : Reactions = Reactions.initFromJson(props.field.getViewValue(props.model))

        currentValue.addMyReaction(reationType)

        props.parent.hidePopover();
        props.parent.onValueChange(currentValue.toJSON())
    }

    return (
        <Popover attachment="top center"
                 targetAttachment="bottom center"
                 popoverClass = "popover-add-reaction"
                 getTargetFunc={()=>findDOMNode(props.parent)}
                 onClickOutside={()=>{props.parent.hidePopover()}}>

            <AddReaction_PopoverContent menuParams={{
                onSelect : onSelect
            }} />

        </Popover>
    );



}
